module.exports = __webpack_public_path__ + "static/yushLogo-614f581505477667de3a1d4ea4ce8713.png";